import { chunkSentence } from "./util"

export const SPEECH_WRAP_COLUMNS = 22
export const SPEECH_CHARACTER_MS = 20
export const SPEECH_HELD_MS = 15000

export const textCharacterDelayMs = (character: string, baseMs: number): number =>
    character.trim() === "," ? baseMs * 12 : character.trim() === "." ? baseMs * 24 : baseMs

/** Reading pause after the typewriter finishes, before the bubble fades. */
export const speechReadingMs = (message: string): number =>
    Math.max(1500, message.split(" ").length * 187.5)

/** Expected bubble occupancy, including reveal, reading, and the browser's fade timers. */
export const speechOccupancyMs = (message: string, hold = false): number => {
    const lines = chunkSentence(message, SPEECH_WRAP_COLUMNS)
    const revealMs = lines.reduce((total, line) => total + line.slice(0, -1).split("")
        .reduce((sum, char) => sum + textCharacterDelayMs(char, SPEECH_CHARACTER_MS), 0), 0)
        + Math.max(0, lines.length - 1)
    // The fade uses 100 timer steps; browsers clamp nested timers to at least 4ms.
    // Allow a small margin for network/render scheduling before admitting another speaker.
    return revealMs + (hold ? SPEECH_HELD_MS : speechReadingMs(message) + 400) + 250
}
